import InAppMessage from "../models/in-app-message.js";
import { _handleBrazeAction as O } from "../../Core/handle-braze-action.js";
import { logInAppMessageButtonClick } from "../log-in-app-message-button-click.js";
import { toRgba as ae } from "../../util/color-utils.js";
import { addPassiveEventListener as J } from "../../util/dom-utils.js";
import { KeyCodes as ie } from "../../util/key-codes.js";
var ne = {
  wo: function wo(t) {
    var o = t.querySelectorAll(".ab-close-button, .ab-message-button");
    var e;
    for (var _t = 0; _t < o.length; _t++) e = o[_t], e.tabIndex = 0;
    if (o.length > 0) {
      var _e = o[0],
        s = o[o.length - 1];
      t.addEventListener("keydown", function (o) {
        var a = document.activeElement;
        o.keyCode === ie.yo && (o.shiftKey || a !== s && a !== t ? !o.shiftKey || a !== _e && a !== t || (o.preventDefault(), s.focus()) : (o.preventDefault(), _e.focus()));
      });
    }
  },
  vo: function vo(t, o) {
    o.setAttribute("role", "dialog"), o.setAttribute("aria-modal", "true"), t ? o.setAttribute("aria-labelledby", t) : o.setAttribute("aria-label", "Modal Message");
  },
  jo: function jo(t, o, e) {
    if (t.buttons && t.buttons.length > 0) {
      var s = document.createElement("div");
      s.className = "ab-message-buttons", o.appendChild(s);
      var a = o.getElementsByClassName("ab-message-text")[0];
      null != a && (a.className += " ab-with-buttons");
      var l = function l(s) {
        return function (a) {
          return t.ll(o, function () {
            logInAppMessageButtonClick(s, t), s.clickAction === InAppMessage.ClickAction.URI && O(s.uri || "", e || t.openTarget === InAppMessage.OpenTarget.BLANK, a);
          }), a.stopPropagation(), !1;
        };
      };
      for (var _o = 0; _o < t.buttons.length; _o++) {
        var _e2 = t.buttons[_o],
          _a = document.createElement("button");
        _a.className = "ab-message-button", _a.setAttribute("type", "button"), J(_a, "touchstart");
        var n = _e2.text;
        "" === _e2.text && (n = " "), _a.appendChild(document.createTextNode(n)), t.Oe() || (_a.style.backgroundColor = ae(_e2.backgroundColor), _a.style.color = ae(_e2.textColor), _a.style.borderColor = ae(_e2.borderColor)), _a.onclick = l(_e2), s.appendChild(_a);
      }
    }
  }
};
export default ne;